import SiafLiteApiRepository from "../../external/siafLiteApi";

class TabelaVendaService {
  constructor() {
    this.urlBase = "/estoque/tabelas-venda";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }

  carregarProdutosLote(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/carregar-produtos-lote`
    ).patch(body);
  }
}

export default TabelaVendaService;
